import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

export default function PricingCards({ onSelect, currentPlan, compact = false }) {
    const { t } = useI18n();
    const nav = useNavigate();
    const [plans, setPlans] = useState(null);

    useEffect(() => {
        api.get("/plans").then(({ data }) => setPlans(data)).catch(() => {});
    }, []);

    if (!plans) return <div className="h-64" />;

    const order = ["basic", "professional"];
    return (
        <div className="grid gap-6 md:grid-cols-2">
            {order.map((key) => {
                const p = plans.plans[key];
                const isPro = key === "professional";
                const isCurrent = currentPlan === key;
                return (
                    <div key={key} data-testid={`plan-card-${key}`}
                        className={`relative flex flex-col rounded-3xl border p-8 transition-transform duration-200 hover:-translate-y-1 ${isPro ? "border-accent bg-primary text-primary-foreground shadow-[0_16px_48px_rgba(0,0,0,0.12)]" : "border-border/70 bg-card"}`}>
                        {isPro && (
                            <span className="absolute -top-3 left-8 rounded-full bg-accent px-3 py-1 text-xs font-semibold text-accent-foreground">
                                {t("marketing.mostPopular")}
                            </span>
                        )}
                        <h3 className={`font-serif text-2xl font-bold ${isPro ? "text-primary-foreground" : ""}`}>{p.name}</h3>
                        <p className={`mt-1 text-sm ${isPro ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                            {isPro ? t("marketing.unlimitedEmployees") : t("marketing.perEmployees")}
                        </p>
                        <div className="mt-6 flex items-baseline gap-1">
                            <span className="font-serif text-5xl font-bold">€{p.price.toFixed(2)}</span>
                            <span className={`text-sm ${isPro ? "text-primary-foreground/70" : "text-muted-foreground"}`}>{t("common.perMonth")}</span>
                        </div>
                        <ul className="mt-8 flex-1 space-y-3">
                            {p.features.map((f) => (
                                <li key={f} className="flex items-start gap-2 text-sm">
                                    <Check className={`mt-0.5 h-4 w-4 shrink-0 ${isPro ? "text-accent" : "text-accent"}`} />
                                    <span className={isPro ? "text-primary-foreground/90" : "text-foreground/90"}>{t(`features_list.${f}`)}</span>
                                </li>
                            ))}
                        </ul>
                        <Button
                            data-testid={`plan-select-${key}`}
                            disabled={isCurrent}
                            onClick={() => (onSelect ? onSelect(key) : nav("/register"))}
                            className={`mt-8 w-full rounded-full ${isPro ? "bg-accent text-accent-foreground hover:bg-accent/90" : ""}`}
                            variant={isPro ? "default" : "outline"}
                        >
                            {isCurrent ? t("billing.current") : (onSelect ? t("billing.switchTo") + " " + p.name : t("common.startTrial"))}
                        </Button>
                    </div>
                );
            })}
        </div>
    );
}
